import * as Common from '@/tenant/common';

export class PartneredTenant extends Common.ObjectBase{
  constructor(){
    super('PartneredTenantResult')
  }
  public tenantId:string;
  public tenantName:string;
  public adminId:string;
  public adminName:string;
  public paymentStatus:number;
  public paidStartDate:Date;
}

export class PartneredTenantQuery extends Common.LoadQuery {
  constructor(){
    super('PartneredTenantQuery',PartneredTenant);
  }
  public tenantId:string;
  public tenantName:string;
}
